class LoginDelegate {
    setEmail(email) {
        this.setState((prevState) => {
            return {
                email,
            };
        });
    }

    setPassword(password) {
        this.setState((prevState) => {
            return {
                password,
            };
        });
    }

    setPasswordVisibility(passwordVisibility) {
        this.setState((prevState) => {
            return {
                passwordVisibility,
            };
        });
    }

    togglePasswordVisibility() {
        this.setPasswordVisibility(this.state.passwordVisibility === 'text' ? 'password' : 'text');
    }
}

export default LoginDelegate;
